import { FIELD_PLACEHOLDER, resolveFieldLabel } from './resolveFieldLabel';

interface ApiErrorInfo {
  field: string;
  message: string;
}

interface ApiError {
  type: string;
  message?: string;
  info?: ApiErrorInfo | ApiErrorInfo[];
}

export function getErrorMessage(apiError: ApiError, translateFn: (key: string) => string): string | undefined {
  if (!apiError?.type) {
    return undefined;
  }

  const info = Array.isArray(apiError.info) ? apiError.info[0] : apiError.info;
  const backendMessage = info?.message;
  if (!backendMessage) {
    return apiError.message;
  }

  if (info?.field && backendMessage.includes(FIELD_PLACEHOLDER)) {
    return backendMessage.replace(FIELD_PLACEHOLDER, resolveFieldLabel(info.field, translateFn));
  }

  return backendMessage;
}
